import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class ShangChengEwm extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.sc_wem}>
                <a href={content.url} target="_blank">
                    <img src={content.image} />
                </a>
            </div>
        );
    }
}

export default errorBoundary(ShangChengEwm);
